import classNames from 'classnames';
import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import styles from './styles.module.scss';

const TrailSegmentsLoading = () => {
  return <ShimmerContainer className={classNames(styles.content, styles.loading)} />;
};

export default TrailSegmentsLoading;
